/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { PageTab } from '@app/components/Guide/ui/PageTab'
import { Section } from '@app/components/Guide/ui/Section'

const HomeContacts = () => {
  return (
    <PageTab
      header="About us"
      subheader="Urban Intelligence serves as the research and advisory team behind the Resilience Explorer® platform, accelerating evidence-based resilience through cutting-edge innovation."
    >
      <Section backgroundColor="#EDF2F4">
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          gap={{ xs: 4, md: 8 }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            component="img"
            src={`${PUBLIC_ASSETS_BASE_URL}/images/onboarding_images/ui-team-2025.jpg`}
            sx={{
              width: { xs: '100%', md: '45%' },
              height: { xs: 'auto', md: '500px' },
              objectFit: 'contain',
              borderBottomRightRadius: { xs: '16px', md: '32px' },
            }}
            alt="Urban Intelligence team"
          />

          <Box
            display="flex"
            flexDirection="column"
            gap={{ xs: 2, md: 4 }}
            width={{ xs: '100%', md: '50%' }}
          >
            <p>
              Our team of 20+ includes leading researchers and innovators across risk, adaptation,
              engineering, social science, and computer science, working alongside academic research
              partners and drawing from ongoing client feedback and co-learning to continuously
              advance our understanding. We are guided by our advisory board, including Michelle van
              Gaalen, Dr Rod Carr, and Nigel Jeffries.
            </p>

            <p>
              Urban Intelligence was founded to transform climate research into practical digital
              solutions that decision-makers can trust and use. As the research engine behind
              Resilience Explorer®, we ensure that evolving risk and resilience research flows
              directly to communities and organisations navigating a changing environment. Through
              digital tools that can be rapidly updated, we ensure decision-makers always have
              access to the latest evidence and understanding. This approach is crucial for climate
              and natural hazard preparation, where both the challenges and solutions are constantly
              evolving. We are learning together in uncharted territory.
            </p>

            <p>
              Climate adaptation is an evolving field where perfect solutions don&apos;t always
              exist. We believe in learning together—combining your local knowledge with our
              technical expertise, the latest academic research, and the collective experience of
              the Resilience Explorer® community.
            </p>
          </Box>
        </Box>
      </Section>
    </PageTab>
  )
}

export default HomeContacts
